// "Alles wissen" follows the width of the horizontal filter group. After a filter change the group can
// grow to its maximum width for a frame or two, until the overflow list moves another filter behind
// "Filter". While the group is at that maximum and filters are already hidden, the root carries
// data-facets-settling and theme_custom.css hides "Alles wissen".
const root = document.documentElement;
const selector = '.facets--horizontal .facets__filters-wrapper';

const resizeObserver = new ResizeObserver(() => {
  const settling = [...document.querySelectorAll(selector)].some((group) => {
    const maxWidth = getComputedStyle(group).maxWidth;
    if (!maxWidth.endsWith('%') || !group.parentElement) return false;
    const limit = (parseFloat(maxWidth) / 100) * group.parentElement.getBoundingClientRect().width;
    return group.getBoundingClientRect().width >= limit - 1 && group.querySelector('[slot="overflow"]');
  });
  root.toggleAttribute('data-facets-settling', settling);
});

const observeFilterGroups = () => {
  for (const group of document.querySelectorAll(selector)) resizeObserver.observe(group);
};

// A filter change renders the section again and can replace the filter group.
const sections = new Set([...document.querySelectorAll('.facets--horizontal')].map((facets) => facets.closest('.shopify-section')));
for (const section of sections) {
  if (section) new MutationObserver(observeFilterGroups).observe(section, { childList: true, subtree: true });
}

observeFilterGroups();

// Shopify Forms renders its submit button in a shadow root, and the app has no variables for typography or
// hover colours. This style sheet gives it those of the primary button; theme-custom.css sets the rest.
const formsButtonStyles = new CSSStyleSheet();
formsButtonStyles.replaceSync(`
  :host button[type='submit'] {
    width: fit-content;
    font-size: var(--font-size--xs);
    letter-spacing: 0.2em;
    line-height: normal;
    text-transform: var(--button-text-case-primary);
    transition: color var(--animation-speed) var(--animation-easing),
      background-color var(--animation-speed) var(--animation-easing);
  }

  :host button[type='submit']:not(:disabled):hover {
    background-color: var(--color-primary-button-hover-background);
    color: var(--color-primary-button-hover-text);
  }
`);

// The app adds the form element to its root element after it loads the form.
const styleForms = () => {
  for (const form of document.querySelectorAll('[data-form-root] > shopify-forms-embed')) {
    const sheets = form.shadowRoot?.adoptedStyleSheets;
    if (sheets && !sheets.includes(formsButtonStyles)) sheets.push(formsButtonStyles);
  }
};

for (const formRoot of document.querySelectorAll('[data-form-root]')) {
  new MutationObserver(styleForms).observe(formRoot, { childList: true });
}

styleForms();
